export default "__VITE_ASSET___q9CR7$z__"